import { classEnum, type EnumType } from "./base";

export const VoucherCharsetEnum = new (class extends classEnum([
    {
        label: "ALPHANUMERIC MIXED CASE (Default)",
        value: "ALNUM_MIXED",
        charset: "abcdefghijkmnopqrstuvwxyzACDEFGHJKLMNPQRTUVWXY123456789",
    },
    {
        label: "ALPHANUMERIC UPPER CASE",
        value: "ALNUM_UPPER",
        charset: "ACDEFGHJKLMNPQRTUVWXY123456789",
    },
    {
        label: "ALPHANUMERIC LOWER CASE",
        value: "ALNUM_LOWER",
        charset: "abcdefghijkmnopqrstuvwxyz123456789",
    },
    {
        label: "ALPHABET MIXED CASE",
        value: "ALPHA_MIXED",
        charset: "abcdefghijkmnopqrstuvwxyzACDEFGHJKLMNPQRTUVWXY",
    },
    {
        label: "ALPHABET UPPER CASE",
        value: "ALPHA_UPPER",
        charset: "ACDEFGHJKLMNPQRTUVWXY",
    },
    {
        label: "ALPHABET LOWER CASE",
        value: "ALPHA_LOWER",
        charset: "abcdefghijkmnopqrstuvwxyz",
    },
] as const satisfies EnumType<{
    charset: string;
}>) {
    public charset(name: VoucherCharsetEnum.Values) {
        return this.select.find((c) => c.value === name)!.charset;
    }
})();

export namespace VoucherCharsetEnum {
    export type Labels = (typeof VoucherCharsetEnum)["labels"][number];
    export type Values = (typeof VoucherCharsetEnum)["values"][number];
}
